export enum cessionActionType {
  SET_HAS_CESSION_CONFIGURATION = 'SET_HAS_CESSION_CONFIGURATION',
}
